var render = function () {
  var _vm$currentRound, _vm$currentRound$acti, _vm$currentRound$acti2, _vm$currentRound2, _vm$currentRound2$act, _vm$currentRound2$act2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customContentContainerStyles": {
        height: '100%'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticClass: "scrolled-secrets",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "left-side"
  }, [_c('div', {
    staticClass: "instructions-scrolled-secrets"
  }, [_c('audio-toggle-button'), _c('span', [_vm._v("Scroll down to read the passage. Move each label to the correct place. Then type the\n            word.")])], 1), _c('div', {
    staticClass: "scrollable-container focusable",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('h3', {
    staticClass: "round-title"
  }, [_vm._v("\n            " + _vm._s(_vm.currentRound.roundTitle) + "\n          ")]), _c('img', {
    attrs: {
      "alt": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$acti = _vm$currentRound.activityImage) === null || _vm$currentRound$acti === void 0 ? void 0 : (_vm$currentRound$acti2 = _vm$currentRound$acti.image) === null || _vm$currentRound$acti2 === void 0 ? void 0 : _vm$currentRound$acti2.description,
      "src": (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$act = _vm$currentRound2.activityImage) === null || _vm$currentRound2$act === void 0 ? void 0 : (_vm$currentRound2$act2 = _vm$currentRound2$act.image) === null || _vm$currentRound2$act2 === void 0 ? void 0 : _vm$currentRound2$act2.src
    }
  }), _vm._l(_vm.currentRound.paragraphs, function (paragraph, idx) {
    return _c('div', {
      key: idx,
      staticClass: "description"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    }), _c('br')]);
  })], 2)]), _c('div', {
    staticClass: "right-side"
  }, [_c('div', {
    staticClass: "sentences-list"
  }, _vm._l(_vm.randomizedCurrentRoundAnswers, function (answer) {
    var _vm$options$answer$an, _vm$options$answer$an2;
    return _c('div', {
      key: answer.answerId,
      class: {
        'sentence-ct': true,
        focusable: true,
        'element-selected': _vm.selectedAnswer === answer,
        'disabled-sentence': _vm.isCurrentlyTyping
      },
      attrs: {
        "tabindex": _vm.selectedAnswer && _vm.selectedAnswer !== answer || _vm.isCurrentlyTyping || (_vm$options$answer$an = _vm.options[answer.answerId]) !== null && _vm$options$answer$an !== void 0 && _vm$options$answer$an.replaced ? -1 : 0,
        "aria-pressed": _vm.selectedAnswer === answer,
        "role": "button"
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDraggableItemEnterEvent(answer, ("droppable-" + (answer.answerId)));
        }
      }
    }, [!((_vm$options$answer$an2 = _vm.options[answer.answerId]) !== null && _vm$options$answer$an2 !== void 0 && _vm$options$answer$an2.replaced) ? _c('div', {
      staticClass: "sentence-item droppables",
      attrs: {
        "id": ("droppable-" + (answer.answerId))
      }
    }, [_c('svg', {
      staticClass: "border-style",
      class: [{
        'element-selected': _vm.selectedElement && _vm.selectedElement.answerId === ("droppable-" + (answer.answerId))
      }],
      attrs: {
        "height": "50",
        "role": "img",
        "width": "160"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.cardBorder)
      }
    }), _c('p', {
      staticClass: "type-line",
      staticStyle: {
        "color": "#737373"
      }
    }, [_vm._v(_vm._s(answer.answer))])]) : _vm._e()]);
  }), 0), _vm.randomizedCurrentRoundQuestions ? _c('div', {
    staticClass: "results-container"
  }, _vm._l(_vm.randomizedCurrentRoundQuestions, function (answer) {
    return _c('div', {
      key: answer.answerId,
      staticClass: "results-row column-row"
    }, [_c('div', {
      staticClass: "sentence-definition"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(answer.label)
      }
    })]), _c('div', {
      staticClass: "sentence-definition"
    }), _c('div', {
      staticClass: "sentence-placeholder target-slot"
    }, [!_vm.options[answer.answerId].replaced ? _c('svg', {
      staticClass: "border-style",
      class: [{
        'selectable-answer': !!_vm.selectedElement
      }],
      attrs: {
        "height": "50",
        "width": "160",
        "aria-label": ("target spot for " + (answer.label)),
        "id": ("droparea-" + (answer.answerId)),
        "tabindex": _vm.isCurrentlyTyping ? -1 : 0
      },
      domProps: {
        "innerHTML": _vm._s(_vm.cardBorderGrey)
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDroppableItemEnterEvent(answer.answerId, answer);
        }
      }
    }) : _vm._e(), _vm.options[answer.answerId].replaced ? _c('svg', {
      staticClass: "border-style dd",
      attrs: {
        "height": "50",
        "width": "160"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.cardBorder)
      }
    }) : _vm._e(), _vm.options[answer.answerId].replaced ? _c('blinking-cursor-text', {
      attrs: {
        "class-name": 'type-line',
        "text": _vm.options[answer.answerId].answer,
        "text-step": _vm.options[answer.answerId].stepNumber,
        "round-id": _vm.progress.roundIndex
      }
    }) : _vm._e()], 1)]);
  }), 0) : _vm._e()])])], 2), _c('article', {
    style: {
      display: _vm.keyboardEnabled ? 'block' : 'none'
    }
  }, [_vm._t("keyboard")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }